module.exports = __webpack_public_path__ + "img/BigGuns1.5757bd3c.png";